module.exports = __webpack_public_path__ + "img/badge-seniors.da57016c.png";